document.addEventListener('DOMContentLoaded', () => {

  let selected = {};

  function recalc() {
    let total = 0;
    let s = { cpu:0, gpu:0, ram:0, storage:0 };

    Object.values(selected).forEach(p => {
      total += p.price;
      s[p.type] = p.score;
    });

    let power =
      s.gpu * 0.45 +
      s.cpu * 0.40 +
      s.ram * 0.10 +
      s.storage * 0.05;

    document.getElementById('pc-total').innerText = `$${total}`;
    document.getElementById('pc-power').innerText = `${Math.round(power)} / 100`;

    document.getElementById('pc-label').innerText =
      power > 80 ? 'Ultra Gaming' :
      power > 60 ? 'High Gaming' :
      power > 40 ? 'Casual Gaming' :
      'Office PC';
  }

  document.querySelectorAll('.pc-card').forEach(card => {
    card.addEventListener('click', () => {

      let type = card.dataset.type;

      document
        .querySelectorAll(`[data-part="${type}"] .pc-card`)
        .forEach(c => c.classList.remove('active'));

      card.classList.add('active');

      selected[type] = {
        variant: card.dataset.id,
        price: parseFloat(card.dataset.price),
        score: parseInt(card.dataset.score),
        type
      };

      recalc();
    });
  });

  document.getElementById('pc-add').addEventListener('click', () => {

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: Object.values(selected).map(p => ({
          id: p.variant,
          quantity: 1
        }))
      })
    }).then(() => {
      window.location.href = '/cart';
    });

  });

});
